import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  Font,
  PDFViewer 
} from "@react-pdf/renderer";
 
// Register the font family
Font.register({
  family: 'Inter',
  fonts: [
    {
      src: '/fonts/Inter-Regular.ttf',
      fontStyle: 'normal',
      fontWeight: '400'
    },
    {
      src: '/fonts/Inter-SemiBold.ttf',
      fontStyle: 'normal',
      fontWeight: '600'
    },
    {
      src: '/fonts/Inter-Bold.ttf',
      fontStyle: 'normal',
      fontWeight: '700'
    }
  ]
});

const styles = StyleSheet.create({
  page: {
    padding: 24,
    fontFamily: "Inter",
    backgroundColor: "#fff",
  },
  section: {
    fontFamily: "Inter",
    marginBottom: 34
  },
  h2: {
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 20,
  },
  p: {
    fontFamily: "Inter",
    fontSize: 12,
    color: "#555",
    marginBottom: 4,
  },
  mb4: {
    marginBottom: 16,
  },
  rounded: {
    borderRadius: 12,
  },
  center: {
    textAlign: "center"
  },
  bgDark: {
    backgroundColor: "#212529",
    color: "#fff"
  },
  textGray500: {
    color: "#64748b"
  },
  textGray700: {
    color: "#334155"
  },
});

function normalizeUrl(url) {
    if (typeof url !== "string") return url;

    // Match all http / https occurrences
    const matches = url.match(/https?:\/\//g);

    // If zero or one protocol → already valid
    if (!matches || matches.length <= 1) {
      return url;
    }

    // Keep everything from the LAST http/https occurrence
    const lastIndex = url.lastIndexOf(matches[matches.length - 1]);
    return url.slice(lastIndex);
  }


const ReportPDF = ({ data }) => (
  <Document>
    <Page style={styles.page}>
      {data?.schema?.map((section, idx) => {
        // Notes
        if (section?.tag === "Notes") {
          return (
            <View key={idx} style={styles.section} wrap={false}>
              <Text style={styles.h2}>{section?.name}</Text>
              {section.fields?.map((element, i) => (
                <Text key={i} style={styles.p}>
                  {element.value || element.placeholder || element.selectedDropdownValue}
                </Text>
              ))}
            </View>
          );
        }

        // Signature
        if (section?.tag === "Signature") {
          return (
            <View key={idx} style={styles.section} wrap={false}>
              <Text style={styles.h2}>{section?.name}</Text>
              <View style={{ flexDirection: "row", flexWrap: "wrap", gap: "10" }}>
                {section.fields?.map((element, i) => (
                  <View key={i} style={{ width: "49%" }}>
                    <Text style={[styles.p, styles.textGray500, { marginBottom: 4 }]}>
                      {element.label}
                    </Text>
                    <Text style={[styles.p, styles.textGray700, { marginBottom: 16 }]}>
                      {removeEmojis(element.value || element.placeholder || element.selectedDropdownValue)}
                    </Text>
                    <Text style={[styles.p, styles.textGray500, { marginBottom: 8, marginTop: 16 }]}>
                      {capitalizeFirstLetter(element.label)} Signature
                    </Text>
                    <View style={{
                      borderWidth: 1,
                      borderColor: "#dee2e6",
                      borderStyle: "solid",
                      borderRadius: 8,
                      padding: 20,
                      height: 120,
                      width: "100%",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#f8fafc"
                    }}>
                      <Text style={{ fontSize: 24, color: "#94a3b8" }}>
                        {element.value || element.placeholder || element.selectedDropdownValue}
                      </Text>
                    </View>
                  </View>
                ))}
              </View>
            </View>
          );
        }

        // Title
        if (section.tag === "Title") {
          return section.fields.map((element, i) => (
            <View key={i} style={{ ...styles.section, ...styles.bgDark, ...styles.center, ...styles.rounded }} wrap={false}>
              <Text style={{ fontSize: 30, fontWeight: 600, padding: 16 }}>
                {element.label || element.placeholder || element.selectedDropdownValue}
              </Text>
            </View>
          ));
        }

        // Photos
        if (section.tag === "Photos") {
          return (
            <View key={idx} style={styles.section} wrap={false}>
              <Text style={styles.h2}>{section.name}</Text>
              <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                {section.fields?.map((element, row) =>
                  element.type === "arrayOfImages"
                    ? element.value.map((photo, i) => {
                      console.log("pjjppjjp111",photo)
                        if(photo?.url == "" ){
                          return null;
                        }
                        return <View
                          key={i}
                          style={{
                            width: "33.33%",
                          }}
                        >
                          <Image
                            src={photo.url || "/images/image-placeholder.jpg"}
                            style={{ width: 170, height: 170, borderRadius: 6 }}
                          />
                          {photo.text ? (
                            <View style={{ marginTop: 8 }}>
                              <Text style={styles.p}>Description</Text>
                              <Text style={styles.p}>{photo.text}</Text>
                            </View>
                          ) : null}
                        </View>
        })
                    : null
                )}
              </View>
            </View>
          );
        }

        // Attachments
        if (section.tag === "Attachments") {
          return (
            <View key={idx} style={styles.section} wrap={false}>
              <Text style={styles.h2}>{section.name}</Text>
              <View style={{ flexDirection: "row", flexWrap: "wrap", gap: "10" }}>
                {section.fields?.map((element) =>
                  element.type === "ArrayOfAttachments"
                    ? element.value.map((attachment, i) => {
                      
                      if (!attachment) return "/images/image-placeholder.jpg";


                      const url =
                        attachment?.url ||
                        attachment?.message?.url ||
                        attachment?.file?.name ||
                        attachment?.message || "";
                      
                      
                      console.log("asasdasd111",url,attachment);
                      const ext = url.split(".").pop()?.toLowerCase() || "";
                      const name = url.split("/").pop()?.toLowerCase() || "";

                      const videoExt = ["mp4", "mov", "avi", "mkv", "webm"];
                      const audioExt = ["mp3", "wav", "aac", "m4a", "ogg"];
                      const docExt = ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "csv"];
                      let icon = "";
                      if (videoExt.includes(ext)) {
                        icon= "/images/file-type-icon-video.svg";
                      }
                      if (audioExt.includes(ext)) {
                        icon= "/images/file-type-icon-audio.svg";
                      }
                      if (docExt.includes(ext)) {
                        icon= "/images/file-type-icon-doc.svg";
                      }
                      console.log("asdasdasdasdasd",icon)

                      return <View
                          key={i}
                          style={{
                            width: "23%",
                          }}
                        >
                          <Image
                            src={icon}
                            style={{ width: 100, height: 130, borderRadius: 6 }}
                          />
                        </View>
                      })
                    : null
                )}
              </View>
            </View>
          );
        }

        // Default
        return (
          <View key={idx} style={styles.section} wrap={false}>
            <Text style={styles.h2}>{section.name}</Text>
            <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
              {section.fields?.map((element, row) => {
                if (element.type === "arrayOfImages") {
                  const images = element.value || [];
                  console.log("imagesaaaapdf",images)
                  return (
                    <View key={row} style={{ flexDirection: "row", flexWrap: "wrap", width: "100%", marginBottom: 20, gap: 8 }}>
                      {images?.map((img,idx) =>{
                        console.log("imgimgimgimg",img)
                        return <Image
                            key={idx}
                            src={
                                  typeof img === "string"
                                    ? img
                                    : img?.preview
                                }
                            style={{ width: "100px", height: "100px", borderRadius: 6 }}
                          />}
                      )}
                    </View>
                  );
                } else if (element.type === "text") {
                  return (
                    <View key={row} style={{ width: "24%", marginBottom: 10, paddingRight: 8, flexShrink: 1 }}>
                      <Text style={[styles.p, styles.textGray500]}>{element.label}</Text>
                      <Text style={[styles.p, styles.textGray700]} wrap>
                        {removeEmojis(element.value || element.placeholder || element.selectedDropdownValue)}
                      </Text>
                    </View>
                  );
                }
                return null;
              })}
            </View>
          </View>
        );
      })}
    </Page>
  </Document>
);

function capitalizeFirstLetter(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// Function to remove emoji characters from text
function removeEmojis(text) {
  if (!text) return text;
  // Remove emoji characters using regex
  // This covers most emoji ranges including flags
  return text.replace(/[\u{1F300}-\u{1F9FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]/gu, '').trim();
}

export default ReportPDF;